import { LazyQueryHookOptions, useLazyQuery } from '@apollo/client'
import alternativeProductsQuery from './query'
import {
  IAlternativeProductsVariables,
  IAlternativeProductsResponse,
} from './types'

/**
 * Hook declaration to obtain a lazy query of the "Opciones similares"
 * (alternative / similar) products for the displayed product-detail SKUs.
 * @param options: LazyQueryHookOptions without the fetch-policy keys
 * @internal
 */
const useLazyAlternativeProducts = (
  options?: Omit<
    LazyQueryHookOptions<
      IAlternativeProductsResponse,
      IAlternativeProductsVariables
    >,
    'fetchPolicy' | 'nextFetchPolicy' | 'initialFetchPolicy'
  >,
) => {
  return useLazyQuery<
    IAlternativeProductsResponse,
    IAlternativeProductsVariables
  >(alternativeProductsQuery, {
    ...options,
    fetchPolicy: 'no-cache',
    // Neutralised beside the pin, not merely omitted from the type: both
    // survive the spread otherwise, and `nextFetchPolicy` would take over
    // from the second fetch onward.
    nextFetchPolicy: undefined,
    initialFetchPolicy: undefined,
  })
}

export { useLazyAlternativeProducts }
